import React, { useContext } from 'react';
import { PermissionContext, RolePermissions } from '../../../../../../appContext';
import { pages } from '../../../common/constant';
import { PermisionDenied } from '../../../common/commonComponents';
import StudentSearchAndListing from './StudentSearchAndListing';


const CentralizedStudentCharges = () => {

    const userPermissions = RolePermissions(useContext(PermissionContext), pages["centralizedRegularCharges"]["id"]);

    return (
        userPermissions
            ? <StudentSearchAndListing />
            : <PermisionDenied />
    );

}

export default CentralizedStudentCharges;